import { LazyLoadImage } from "react-lazy-load-image-component";

const SandhillsImage = (props) => {
    return (      
        <div className={props.divClass ? props.divClass : ''}>
            {props.destinationURL ?
                <a href={props.destinationURL}>{image}</a>
                :
                <LazyLoadImage
                    src={props.src}
                    className={props.className}
                    alt={props.alt}
                    height={props.height}
                    width={props.width}
                />}
        </div>
    );
};

export default SandhillsImage;